var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAstraLinuxWhitecolor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sp",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 659.7 247.5",
    style: {
      enableBackground: "new 0 0 659.7 247.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#0079C1;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.3,99.1h9.7l18.4,65.7h-8l-5.2-18.9H90.4l-4.8,18.9h-8L96.3,99.1z M101,104.4h-0.2l-8.7,35h17.3L101,104.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.3,144c0,9.7,2.7,15.8,12.4,15.8c7.4,0,12.5-3.2,12.5-10.9c0-8.5-4-10.6-10.7-13.1l-9.7-3.6 c-6-2.3-10.6-6.8-10.6-17.2s7.2-17,17.9-17c11.4,0,18.2,6.5,18.7,18.5h-7.3c0-7.2-3.6-12-10.9-12c-8.1,0-10.9,4.9-10.9,10.4 c0,6,1.6,8.7,5.8,10.2L155,129c10.4,3.9,14.7,10.1,14.7,18.8c0,12.4-7.7,18.6-20.3,18.6s-19.5-8.2-19.5-22.3L137.3,144L137.3,144 L137.3,144L137.3,144z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.1,164.8h-7.3v-59.1h-17.1v-6.6H215v6.6h-17L198.1,164.8L198.1,164.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.5,164.8h-7.3V99.1h20c11.5,0,19.1,5.6,19.1,17.9c0,7.5-4.3,14.1-11.9,15.1v0.2c6.9,0.8,11.2,6.8,11.2,14.9 c0,13.7,1.2,14.1,2.2,16.2v1.5h-7.4c-1.5-4.3-2.1-8.1-2.1-15.2c0-8.7-3.8-13.7-12-13.7h-11.9L230.5,164.8L230.5,164.8z M230.5,129.3 h12.7c5.1,0,11.5-2.4,11.5-12c0-9.5-5.4-11.6-11.8-11.6h-12.4V129.3L230.5,129.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.2,99.1h9.7l18.4,65.7h-8l-5.2-18.9h-20.7l-4.8,18.9h-8L290.2,99.1z M294.9,104.4h-0.2l-8.7,35h17.3 L294.9,104.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.9,158.3h26.8v6.6h-34.1V99.1h7.3L359.9,158.3L359.9,158.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M402.9,164.8h-7.3V99.1h7.3V164.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M428.1,99.1l18.6,53.8c0.8,2.3,1.5,4.2,2.3,7.2h0.3c-0.1-2.4-0.3-4.9-0.3-7.3V99.1h7.3v65.7h-12L426,112.3 c-1.1-3-1.8-5.9-2.5-9.9h-0.2c0.1,3.3,0.2,6.7,0.2,10v52.4h-7.3V99.1H428.1L428.1,99.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477,99.1v47.3c0,5.1,0.7,13.4,12.4,13.4c11.7,0,12.4-8.3,12.4-13.4V99.1h7.3V149c0,11.7-7.8,17.3-19.7,17.3 c-12,0-19.7-5.6-19.7-17.3V99.1H477L477,99.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M527,99.1l13.8,25.6l13.8-25.6h8.1L545.1,131l18,33.8h-8.3l-14-27.5l-14.2,27.5h-8.1l18.2-33.8L519,99.1H527 L527,99.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430,194.6H78c-13.8,0-25.1-11.2-25.1-25.1V92.1C53,78.2,64.2,67,78,67h226.2c2,0,3.7-1.6,3.7-3.7l0,0 c0-2-1.6-3.7-3.7-3.7H78c-17.9,0-32.4,14.5-32.4,32.4v77.4c0,17.9,14.5,32.4,32.4,32.4h352V194.6L430,194.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M582,59.6H356c-2,0-3.7,1.6-3.7,3.7l0,0c0,2,1.6,3.7,3.7,3.7h226c13.8,0,25.1,11.2,25.1,25.1v77.4 c0,13.9-11.2,25.1-25.1,25.1H430v7.3h152c17.9,0,32.4-14.5,32.4-32.4V92.1C614.4,74.2,599.9,59.6,582,59.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.5,47.8l-19.3-3.3c-1.7-3.5-7.3-15.4-7.3-15.4l-1.8-3.9l-9.2,19.3l-19.3,3.3l13.8,14.9l-3.1,21.2 l17.8-9.8l17.8,9.7l-3.1-21.2c2.5-2.7,10.8-11.7,11.2-12.2L358.5,47.8z M342.2,61.8l2.6,17.7L330,71.3l-14.8,8.1l2.6-17.7 l-11.5-12.5l16.1-2.8l7.6-16l7.6,16l16.1,2.8L342.2,61.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "319.2,65 324.5,72.3 326.8,71.1 317.9,52.6 329.6,69.5 330,69.3 334.1,71.5 325.1,51.7 340.4,75  342.5,76.2 342.2,73.9 332.3,50.8 340.8,64.4 340.3,61.2 342.9,58.4 339.5,49.9 343.9,57.3 350.2,50.5 336.4,48.1 330,34.6  323.6,48.1 309.8,50.5 319.7,61.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "318.6,68.9 317.5,76.2 321.3,74.1  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M584.3,107.5c0,4.8-3.8,8.6-8.6,8.6c-4.7,0-8.6-3.8-8.6-8.6c0-4.7,3.9-8.6,8.6-8.6 C580.5,98.9,584.3,102.7,584.3,107.5z M568.4,107.5c0,4.1,3.2,7.3,7.3,7.3s7.3-3.2,7.3-7.3c0-4-3.2-7.3-7.3-7.3 S568.4,103.4,568.4,107.5z M572.5,102.6h4.2c1.6,0,3.4,0.5,3.4,2.6c0,1.9-1.5,2.6-3,2.6l2.9,4.4h-1.4l-2.7-4.4h-2.1v4.4h-1.2v-9.6 H572.5z M573.7,106.9h2.8c0.9,0,2.4-0.2,2.4-1.8c0-1.4-1.3-1.6-2.5-1.6h-2.7V106.9L573.7,106.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstraLinuxWhitecolor);
export default __webpack_public_path__ + "static/media/astra_linux_white+color.4901fe4a56c991900068e872a900023e.svg";
export { ForwardRef as ReactComponent };